module.exports = __webpack_public_path__ + "img/bg.207925c8.png";